module.exports = __webpack_public_path__ + "img/phone-grey.46470e40.svg";